import React, { useState } from 'react';
import './DashboardStyle.css';
import { useNavigate } from 'react-router-dom';
import ApiSender from '../common/ApiLogic';

function DashboardPage() {

  const apiSender = new ApiSender();
  const navigate = useNavigate();
  const [msisdn, setMsisdn] = useState('');

  const handleMsisdnChange = (event) => {
    setMsisdn(event.target.value);
  };

  const handleMsisdnFocus = () => {
    changeBorderColor(document.getElementById("div-msisdn"));
    changeColor(document.getElementById("msisdn-span"));
    addFocus(document.getElementById("msisdn-span"));
  }

  const handleMsisdnBlur = () => {
    if (msisdn.length !== 0) {
      addFocus(document.getElementById("msisdn-span"));
      revertBorderColor(document.getElementById("div-msisdn"));
      revertColor(document.getElementById("msisdn-span"));
      return;
    }
    revertBorderColor(document.getElementById("div-msisdn"));
    revertColor(document.getElementById("msisdn-span"));
    removeFocus(document.getElementById("msisdn-span"));
  }

  const addFocus = (element) => {
    element.style.transform = 'translate(14px, -12px) scale(0.75)';
    element.style.backgroundColor = 'rgba(33, 28, 23, .8)';
    element.style.backdropFilter = 'blur(10px)';
    element.style.webkitBackdropFilter = 'blur(10px)';
    element.style.paddingLeft = '10px';
    element.style.paddingRight = '10px';
  }

  const removeFocus = (element) => {
    element.style.transform = '';
    element.style.backgroundColor = '';
    element.style.backdropFilter = '';
    element.style.webkitBackdropFilter = '';
    element.style.paddingLeft = '';
    element.style.paddingRight = '';
  }

  const changeColor = (element) => {
    element.style.color = 'rgba(255, 255, 255, 1)';
  }

  const revertColor = (element) => {
    element.style.color = '';
  }

  const changeBorderColor = (element) => {
    element.style.borderColor = 'rgba(33, 28, 23, 1)';
  }

  const revertBorderColor = (element) => {
    element.style.borderColor = '';
  }

  const search = async () => {
    try {
      if (!isZain(msisdn)) {
        document.getElementById("dashboard-alert").style.opacity = 1;
        document.getElementById("dashboard-msg-result").textContent = 'Invalid Phone Number';
        return;
      }

      document.getElementById("dashboard-alert").style.opacity = 0;
      document.getElementById("dashboard-msg-result").textContent = '';
      const searchResult = await apiSender.search(msisdn);
      if (!searchResult.success) {
        const searchResultCode = searchResult.code;
        if (searchResultCode === 4001) {
          localStorage.removeItem('token');
          localStorage.removeItem('expiration');
          navigate("/");
          window.location.reload();
          return;
        }
        document.getElementById("dashboard-alert").style.opacity = 1;
        document.getElementById("dashboard-msg-result").textContent = searchResult.message;
        return;
      }
      if (searchResult.empty) {
        document.getElementById("dashboard-alert").style.opacity = 1;
        document.getElementById("dashboard-msg-result").textContent = "No data found";
        return;
      }
      const coreFlex = searchResult.coreFlex;
      const powerPlay = searchResult.powerPlay;
      const data = { msisdn: msisdn, coreFlex: coreFlex, powerPlay: powerPlay };
      navigate("/info", { state: data });
    }
    catch (error) {
    }
  }

  const isZain = (msisdn) => {
    if (msisdn !== null && msisdn !== undefined) {
      return (msisdn.length === 13 && (msisdn.startsWith('96478') || msisdn.startsWith('96479')))
        || (msisdn.length === 11 && (msisdn.startsWith('078') || msisdn.startsWith('079')))
        || (msisdn.length === 10 && (msisdn.startsWith('78') || msisdn.startsWith('79')));
    }
    return false;
  }

  return (
    <div className="dashboard">
      <header className="cc-topbar">
        <div className="cc-brand">
          <svg className="cc-mark" viewBox="0 0 48 48" aria-hidden="true">
            <g fill="none" stroke="currentColor" strokeWidth="1.6">
              <circle cx="24" cy="24" r="3.4" />
              <ellipse cx="24" cy="24" rx="5.4" ry="15" />
              <ellipse cx="24" cy="24" rx="5.4" ry="15" transform="rotate(45 24 24)" />
              <ellipse cx="24" cy="24" rx="5.4" ry="15" transform="rotate(90 24 24)" />
              <ellipse cx="24" cy="24" rx="5.4" ry="15" transform="rotate(135 24 24)" />
            </g>
          </svg>
          <div className="cc-lock">
            <b>AL&middot;HORIZON</b>
            <span>Customer Care</span>
          </div>
        </div>
        <div className="cc-partner">Operated for Zain Iraq</div>
      </header>

      <div className="dashboard-stage">
        <svg className="dashboard-lookup" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden="true">
          <circle cx="11" cy="11" r="7" />
          <path d="m21 21-4.3-4.3" />
        </svg>
        <h1>Find a subscription</h1>
        <p>Enter a Zain Iraq mobile number to pull up CoreFlex and PowerPlay details.</p>

        <div className="dashboard-search">
          <div id='div-msisdn' className='cc-field div-msisdn'>
            <span id='msisdn-span'>Phone Number</span>
            <div className='cc-field-input msisdn-input'>
              <input type="text" autoComplete="off" minLength={10} maxLength={13} placeholder=" " required onChange={handleMsisdnChange} onFocus={handleMsisdnFocus} onBlur={handleMsisdnBlur} />
            </div>
          </div>
          <button className="cc-btn cc-btn-primary" onClick={search}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="m21 21-4.3-4.3" /></svg>
            Search
          </button>
        </div>

        <div id='dashboard-alert' className='alert'>
          <div className='left-alert'>
            <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24"><path d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path></svg>
          </div>
          <div className='right-alert'>
            <span id="dashboard-msg-result" className='message'></span>
          </div>
        </div>
      </div>
    </div>
  );

}
export default DashboardPage;